import { createAction } from "@reduxjs/toolkit";
import { PRIMARY_HEX } from "../../theme/primary";

export const authSetUser = createAction("auth/setUser", (idsObj) => {
  return {
    payload: idsObj,
  };
});

export const authClearUser = createAction("auth/clearUser", () => {
  return { payload: null };
});

export const updateBrandColor = createAction("brandColor", (color) => {
  return {
    payload: { brandColor: color || PRIMARY_HEX },
  };
});

export const setUserData = createAction("user/setUser", (idsObj) => {
  return {
    payload: idsObj,
  };
});

// export const toggleState = createAction("changeState", (state) => {
//   return {
//     payload: state,
//   };
// });
